export default __webpack_public_path__ + "../images/slider-1.png";